import React from 'react';
import { X } from 'lucide-react';
import './whatsapp-connection-modal.css';

export default function WhatsAppConnectionModal({
  title,
  subtitle,
  onClose,
  children,
}) {
  return (
    <div className="whatsapp-connection-modal">
      <header className="whatsapp-connection-modal__header">
        <div className="whatsapp-connection-modal__heading">
          <h3>{title}</h3>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        <button
          type="button"
          className="whatsapp-connection-modal__close"
          onClick={onClose}
          aria-label="Fechar modal"
        >
          <X size={16} />
        </button>
      </header>
      <div className="whatsapp-connection-modal__body">
        {children}
      </div>
    </div>
  );
}
